export default __webpack_public_path__ + "static/media/background_radiaion.496cddeb.jpg";